import { useRef, useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Table, Input, Space, Button, Modal, Select, DatePicker } from "antd";
import { SearchOutlined, ExclamationCircleFilled } from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import { Container } from "./styled";
import { AppContext } from "../../utils/AppContext";
import { USER_ROLE } from "../../constants";
import request from 'utils/request';
import { BASE_API_URL } from 'constants/api';
import axios from 'axios';

const { Column } = Table;
const { RangePicker } = DatePicker;

const AggregationType = {
  0: 'Daily',
  1: 'Weekly',
  2: 'Monthly',
  3: 'Yearly',
};

const TeamTableComponent = (props) => {
  const { datas, isLoading, handleReloadData } = props;
  const { userInfo } = useContext(AppContext);
  const { confirm } = Modal;
  const navigate = useNavigate();
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const [dataValues, setDataValues] = useState([]);

  const searchInput = useRef(null);

  // Add new state for TrainingReport


  useEffect(() => {
    if(datas.length > 0) {
      setDataValues(datas)
    }
  }, [datas])

  const showDeleteConfirm = (user) => {
    confirm({
      title: `Are you sure you want to ${user.totalTrainingTime > 0 ? "reset" : "undelete"} all data for ${user.username}?`,
      icon: <ExclamationCircleFilled />,
      content: 'All your data will be initialized.',
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      onOk() {
        handleOk(user)
      },
      onCancel() {
        handleCancel()
      },
    });
  };

  const updateTableData = (data, updates) => {
    let copyData = JSON.parse(JSON.stringify(data));
    let id = updates.VR_APP_SESSION;
    let findIndex = copyData.findIndex((item) => item.VR_APP_SESSION === id);
    if(findIndex !== -1) {
      copyData[findIndex].HAZMAT_SCORE = updates.HAZMAT_SCORE;
      copyData[findIndex].GUN_SCORE = updates.GUN_SCORE;
      setDataValues(copyData);
      handleReloadData();
    }
  }

  const handleOk = async(user) => {
    if(user) {
      // delete request to backend
      const data = {
        "userId": user.id,
        "isDeleted": user.totalTrainingTime > 0 ? true : false
      }
      const config_delete_user_data = {
        method: 'post',
        url: `${BASE_API_URL}/user/attempts/set-deleted`,
        data: data
      }
      let res = await request(config_delete_user_data);
      if(res.affectedAttempts > 0) {
        handleReloadData();
      }
    }
    
  };

  const handleCancel = () => {
  };

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };

  const handleRowClick = (record, index) => {
    if(userInfo.user_role === undefined) return;
    if(userInfo.user_role !== USER_ROLE.STUDENT) {
      navigate(`/precimar_ulm_600_e/${record.lastTrainingAttemptId}`);
      localStorage.setItem("sessionId", record.lastTrainingAttemptId);
    } 
  }

  const handleCellClick = async(record, index) => {
    if(userInfo.user_role === undefined) return;

    if(userInfo.user_role !== USER_ROLE.STUDENT) {
      showDeleteConfirm(record);
    } 
  }

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              setSearchText(selectedKeys[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filter
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });


  return (
    <Container style={{width: "100%"}}>
      <Table dataSource={dataValues} style={{cursor: "pointer"}} loading={isLoading}>
        <Column
          key="USER_NUM"
          dataIndex="USER_NUM"
          title="No"
          sorter={{ compare: (a, b) => a.USER_NUM > b.USER_NUM }}
          {...getColumnSearchProps("USER_NUM")}
          onCell={(record, rowIndex) => {
            return {
              onClick: event => {
                handleRowClick(record, rowIndex)
              }, // click row
            };
          }} 
          
        />
        <Column
          key="USER_ID"
          dataIndex="USER_ID"
          title="User ID"
          sorter={{ compare: (a, b) => a.USER_ID > b.USER_ID }}
          {...getColumnSearchProps("USER_ID")}
          onCell={(record, rowIndex) => {
            return {
              onClick: event => {
                handleRowClick(record, rowIndex)
              }, // click row
            };
          }} 
          
        />
        
        <Column
          key="USER_ROLE"
          dataIndex="role"
          title="User Role"
          sorter={{ compare: (a, b) => a.USER_ROLE > b.USER_ROLE }}
          {...getColumnSearchProps("USER_ROLE")}
          onCell={(record, rowIndex) => {
            return {
              onClick: event => {
                handleRowClick(record, rowIndex)
              }, // click row
            };
          }} 
        />
        <Column
          key="totalTrainingTime"
          dataIndex="totalTrainingTime"
          title="Training Time"
          sorter={{ compare: (a, b) => a.totalTrainingTime > b.totalTrainingTime }}
          render={(text) => Math.ceil(parseFloat(text)/60)}
          onCell={(record, rowIndex) => {
            return {
              onClick: event => {
                handleRowClick(record, rowIndex)
              }, // click row
            };
          }} 
        />
        <Column
          key="averageScore"
          dataIndex="averageScore"
          title="Average Score"
          sorter={{ compare: (a, b) => a.averageScore > b.averageScore }}
          render={(text) => Math.round(text)}
          onCell={(record, rowIndex) => {
            return {
              onClick: event => {
                handleRowClick(record, rowIndex)
              }, // click row
            };
          }} 
        />
        <Column
          key="lastTrainingDate"
          dataIndex="lastTrainingDate"
          title="Last Session"
          render={(text) => text ? new Date(text).toLocaleDateString() : "N/A"}
          sorter={{ compare: (a, b) => a.averageScore > b.averageScore }}
          onCell={(record, rowIndex) => {
            return {
              onClick: event => {
                handleRowClick(record, rowIndex)
              }, // click row
            };
          }} 
        />
        {/* <Column
          key="lastTrainingAttemptId"
          dataIndex="lastTrainingAttemptId"
          title="Last Training Attempt"
          render={(text) => text ? text : "N/A"}
          sorter={{ compare: (a, b) => a.averageScore > b.averageScore }}
          onCell={(record, rowIndex) => {
            return {
              onClick: event => {
                handleRowClick(record, rowIndex)
              }, // click row
            };
          }} 
        />         */}
      {/* only show the reset button for users in the list other than instructor id 1 */}
        <Column
          title="Action"
          dataIndex=""
          key="x"
          align="center"
          render={(record) => record.id !== 1 ? <a href="#top">{record.totalTrainingTime > 0 ? "reset" : "undelete"}</a> : null}
          onCell={(record, rowIndex) => {
            if(record.id === 1) return {};
            return {
              onClick: event => {
                event.preventDefault();
                handleCellClick(record, rowIndex)
              }, // click row
            };
          }} 
        />
      </Table>
      
      {/* TrainingReport content */}
      {/* <h2 style={{ marginTop: '2rem' }}>Training Report</h2>
      <Space style={{ marginBottom: '1rem' }}>
        <Input
          type="number"
          placeholder="User ID"
          value={userId}
          onChange={(e) => setUserId(e.target.value ? parseInt(e.target.value) : '')}
        />
        <Input
          type="number"
          placeholder="Training ID"
          value={trainingId}
          onChange={(e) => setTrainingId(e.target.value ? parseInt(e.target.value) : '')}
        />
        <RangePicker
          value={dateRange}
          onChange={(dates) => setDateRange(dates)}
        />
        <Select
          value={aggregationType}
          onChange={(value) => setAggregationType(value)}
          style={{ width: 120 }}
        >
          {Object.entries(AggregationType).map(([key, value]) => (
            <Select.Option key={key} value={parseInt(key)}>
              {value}
            </Select.Option>
          ))}
        </Select>
        <Button type="primary" onClick={fetchReport}>Fetch Report</Button>
      </Space>
      <Table
        dataSource={reportItems}
        rowKey={(record, index) => index}
        pagination={{ pageSize: 10 }}
      >
        <Column title="Date" dataIndex="date_printabble" key="date_printabble"  />
        <Column title="User Name" dataIndex="userName" key="userName" />
        <Column title="Training Title" dataIndex="trainingTitle" key="trainingTitle" />
        <Column title="Attempt Count" dataIndex="attemptCount" key="attemptCount" />
        <Column
          title="Total Time"
          dataIndex="totalTime"
          key="totalTime"
          render={(text) => text.toFixed(2)}
        />
        <Column
          title="Average Score"
          dataIndex="averageScore"
          key="averageScore"
          render={(text) => text.toFixed(2)}
        />
        <Column
          title="Success Rate"
          dataIndex="successRate"
          key="successRate"
          render={(text) => `${(text * 100).toFixed(2)}%`}
        />
      </Table> */}
    </Container>
  );
};

export default TeamTableComponent;
